module.exports = __webpack_public_path__ + "media/images/icons/outlined/menu-unfold-baeb1a7248aa00adee70a33262a6f84a.svg";